import styleClasses from './css/Loading.module.scss';

const Loading = ({ message }) => {
    return (
      <div className={styleClasses.loading}>
        <img src={`${process.env.PUBLIC_URL}/assets/images/logo.webp`} alt="MusiCards" />
        <div className={styleClasses.loadingBorder}></div>
        <div className={styleClasses.loadingBorder}></div>
        <div className={styleClasses.loadingBorder}></div>
        <div className={styleClasses.loadingBackground}></div>
        { message && <p className={styleClasses.loadingMessage}>{ message }</p> }
      </div>
    );
}
export default Loading;